/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Network_Vehicle_Operator_AllInputs */

const fr_network_vehicle_operator_all = /** @type {(inputs: Network_Vehicle_Operator_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tous les opérateurs`)
};

const en_network_vehicle_operator_all = /** @type {(inputs: Network_Vehicle_Operator_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All operators`)
};

/**
* | output |
* | --- |
* | "All operators" |
*
* @param {Network_Vehicle_Operator_AllInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const network_vehicle_operator_all = /** @type {((inputs?: Network_Vehicle_Operator_AllInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Network_Vehicle_Operator_AllInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_network_vehicle_operator_all(inputs)
	return en_network_vehicle_operator_all(inputs)
});